import PropTypes from "prop-types";
import "../dashboard-consumer-retail/dashboard-consumer-retail.scss";
import DashboardProjectTimeLog from "./dashboard-project-time-log/dashboard-project-time-log.jsx";
import DashboardMemberTimeLog from "./dashboard-member-time-log/dashboard-member-time-log.jsx";
import { DashboardGridSkeleton } from "../dashboard-skeletons/dashboard-skeletons.jsx";

const DashboardConsumerRetail = (props) => {
    return (
        <div>
            {props.isConsumerMemberLoading 
                ? <DashboardGridSkeleton /> 
                : <DashboardMemberTimeLog items={props.memberItems} fetchData={props.fetchData} />
            }
            {props.isConsumerProjectLoading 
                ? <DashboardGridSkeleton /> 
                : <DashboardProjectTimeLog items={props.projectItems} />
            }        
        </div>
    );
};

DashboardConsumerRetail.propTypes = {
    memberItems: PropTypes.array,
    projectItems: PropTypes.array,
    fetchData: PropTypes.func,
    isConsumerMemberLoading: PropTypes.bool,
    isConsumerProjectLoading: PropTypes.bool,
  };

export default DashboardConsumerRetail;
